<template>
    <div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    export default {
        name: 'callback',
        methods: {
            ...mapActions('oidcStore', [
                'oidcSignInCallback'
            ])
        },
        created() {
            this.oidcSignInCallback()
                .then((redirectPath) => {
                    this.$router.push(redirectPath);
                })
                .catch((err) => {
                    console.error("callback", err);
                    this.$router.push('/') // Handle errors any way you want
                })
        }
    }
</script>
